namespace TabAurous.OMS {
    export interface MarkupChargesRow {
        MarkupChargesId?: number;
        MarkUpPolicyId?: number;
        MarkUpType?: Common.MarkUpType;
        ItemTypeId?: number;
        ItemType?: string;
        ProductTypeId?: number;
        ProductTypeCode?: string;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneColorId?: number;
        KaratId?: number;
        MetalColorId?: number;
        ProcessId?: number;
        SettingId?: number;
        MarkUpRateType?: Common.MarkUpRateType;
        MarkUp?: number;
    }

    export namespace MarkupChargesRow {
        export const idProperty = 'MarkupChargesId';
        export const localTextPrefix = 'OMS.MarkupCharges';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            MarkupChargesId = "MarkupChargesId",
            MarkUpPolicyId = "MarkUpPolicyId",
            MarkUpType = "MarkUpType",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            ProductTypeCode = "ProductTypeCode",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneColorId = "StoneColorId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            ProcessId = "ProcessId",
            SettingId = "SettingId",
            MarkUpRateType = "MarkUpRateType",
            MarkUp = "MarkUp"
        }
    }
}
